<template>
	<div class="searchbar">
		<div class="wrap">
			<slot/>

			<div class="button-area">
				<b-button type="is-info" @click="onSearchClick">検索</b-button>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.searchbar {
	padding: 30px .75rem;
	border-bottom: 1px solid rgba(24, 28, 33, 0.06);

	.wrap {
		display: flex;
		align-items: center;

		.button-area {
			min-width: 150px;
			text-align: right;
			margin-left: auto;
		}
	}
}
</style>

<script>

export default {
	name: 'SearchBar',
	props: {
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	methods: {
		onSearchClick: function() {
			this.$emit('search');
		},
	},
}
</script>
